import UserName from "./UserName";
import UserLink from "./UserLink";


import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="User-detail-title"
                    >
                        { label || t`User` }: <UserName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="User-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="User-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="email-label"><Trans>Email</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="email-value" >{ data.email || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="activated-label"><Trans>Activated</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="activated-value" >{ data.activated ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="banned-label"><Trans>Banned</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="banned-value" >{ data.banned ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="createdAt-label"><Trans>Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="createdAt-value" >{displayDateTime(data.createdAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="updatedAt-label"><Trans>Updated At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="updatedAt-value" >{displayDateTime(data.updatedAt) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="userGroupId-label"><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="userGroupId-value" >{ data.userGroupId ? (<MembersGroupLink id={ data.userGroupId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default UserDetail;
